import {createSelector} from 'reselect';
import {isMobile} from './DeviceSelectors';
import getDesktopBanner from './getDesktopBanner';
import getMobileBanner from './getMobileBanner';

export default createSelector(
  [getMobileBanner, getDesktopBanner, isMobile],
  (mobileBanner, desktopBanner, mobile) => (mobile ? mobileBanner : desktopBanner),
);
